module.exports = __webpack_public_path__ + "service.99c6b573.png";